import {
  faHome,
  faSearch,
  faCog,
  faLifeRing,
  faCartShopping,
  faSquareList,
  faTags,
  faStar,
  faMagicWandSparkles,
  faBagShopping,
  faBell,
  faStore,
} from "@fortawesome/pro-light-svg-icons";
import { paths } from "~/router/paths";
import { INavItem } from "~/types/routing";
import {
  useGetSidebarCountLiveProducts,
  useGetSidebarCountImportedProducts,
  useGetSidebarCountShopifyOrders,
  useGetSidebarCountSampleOrders,
} from "~/api/sidebarCounts/queries";
import { DISABLE_PAYMENTS } from "~/helpers/plans";
import { useGetUnreadNotifications } from "~/api/notifications/queries";
import {
  triggerShowConnectStoreModal,
  triggerShowNotifications,
} from "~/helpers/customEvents";

const starIcon =
  "https://s3.us-west-2.amazonaws.com/assets.spocket.co/star.svg";

// @ts-ignore
import { ReactComponent as DropshipToolLogo } from "~/assets/svg/dropshiptool_logo.svg";

export const navItems: Array<INavItem> = [
  {
    sectionLabel: "nav.title_home",
    namePath: "nav.dashboard",
    path: paths.app.home,
    icon: faHome,
    hideOnMobile: false,
  },
  {
    namePath: "nav.winning_ads",
    path: paths.app.winningAds,
    icon: DropshipToolLogo,
    hideOnMobile: false,
  },
  {
    sectionLabel: "nav.title_find_products",
    namePath: "nav.mobile_aliexpress_products",
    path: paths.app.aliexpressProducts,
    icon: faSearch,
    hideOnMobile: true,
  },
  {
    namePath: "nav.winning_products",
    path: paths.app.winningProducts,
    icon: faStar,
    hideOnMobile: false,
  },
  {
    namePath: "nav.us_eu_products",
    path: paths.app.usEuProducts,
    icon: faCartShopping,
    hideOnMobile: false,
  },
  {
    sectionLabel: "nav.title_products",
    namePath: "nav.import_list",
    path: paths.app.importList,
    icon: faSquareList,
    getCountQuery: useGetSidebarCountImportedProducts,
    hideOnMobile: true,
  },
  {
    namePath: "nav.live_products",
    path: paths.app.liveProducts,
    icon: faTags,
    getCountQuery: useGetSidebarCountLiveProducts,
    hideOnMobile: true,
  },
  {
    namePath: "nav.reviews",
    path: paths.app.promoReviews,
    icon: starIcon as any,
    isOnlySVG: true,
    hideOnMobile: false,
    isNew: true,
  },

  {
    namePath: "nav.orders",
    path: paths.app.orders,
    icon: faCartShopping,
    getCountQuery: useGetSidebarCountShopifyOrders,
    hideOnMobile: true,
  },
  {
    namePath: "nav.sample_orders",
    path: paths.app.sampleOrders,
    icon: faBagShopping,
    getCountQuery: useGetSidebarCountSampleOrders,
    hideOnMobile: false,
  },
  {
    sectionLabel: "nav.title_premium",
    namePath: "nav.product_analyzer",
    path: paths.app.productAnalyzer,
    icon: faMagicWandSparkles,
    hideOnMobile: false,
  },
  {
    namePath: "settings.title",
    path: DISABLE_PAYMENTS ? paths.settings.account : paths.settings.plans,
    icon: faCog,
    hideOnMobile: false,
  },
  {
    namePath: "nav.notifications",
    path: "/notifications",
    icon: faBell,
    onClick: () => triggerShowNotifications(),
    getCountQuery: useGetUnreadNotifications,
    hideOnMobile: false,
  },
  {
    namePath: "nav.connect-store",
    path: "/connect-store",
    icon: faStore,
    onClick: () => triggerShowConnectStoreModal(),
    hideOnMobile: false,
  },
  {
    namePath: "nav.help_center",
    path: "https://www.notion.so/AliDrop-20a0c13273a280619329ddb6b9101156",
    openInNewTab: true,
    icon: faLifeRing,
    hideOnMobile: false,
    // Uncomment this to show help center as a modal
    showHelpCenterModal: false,
  },
];
